import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["range", "input"]

  connect() {
    this.syncInputFromRange()
  }

  syncInputFromRange() {
    if (this.hasRangeTarget && this.hasInputTarget) {
      this.inputTarget.value = this.rangeTarget.value
    }
  }

  syncRangeFromInput() {
    if (this.hasRangeTarget && this.hasInputTarget) {
      // Only update range slider, don't modify input while typing
      const value = parseFloat(this.inputTarget.value)
      if (!isNaN(value)) {
        const min = parseFloat(this.rangeTarget.min) || 0
        const max = parseFloat(this.rangeTarget.max) || 5
        this.rangeTarget.value = Math.max(min, Math.min(max, value))
      }
    }
  }

  // Called on blur to clamp and format the final value
  finalizeInput() {
    if (this.hasRangeTarget && this.hasInputTarget) {
      let value = parseFloat(this.inputTarget.value) || 0
      const min = parseFloat(this.rangeTarget.min) || 0
      const max = parseFloat(this.rangeTarget.max) || 5
      value = Math.max(min, Math.min(max, value))
      this.inputTarget.value = value
      this.rangeTarget.value = value
    }
  }

  rangeValueChanged() {
    this.syncInputFromRange()
  }
}